import { PropsWithChildren, useCallback } from 'react';
import { StyledTagList, StyledTag, DeleteButton } from './Tag.styles';

type TagListProps = PropsWithChildren<{}>;

export function TagList({ children }: TagListProps) {
  return <StyledTagList>{children}</StyledTagList>;
}

type TagProps = PropsWithChildren<{
  highlight?: boolean;
  color?: string;
  size?: 'small' | 'medium' | 'large';
  onDelete?: () => void;
}>;

function Tag({
  size = 'medium',
  color = '#444',
  highlight,
  onDelete,
  children,
  ...rest
}: TagProps) {
  const handleOnDelete = useCallback(
    (event) => {
      event.stopPropagation();
      event.preventDefault();
      if (typeof onDelete === 'function') {
        onDelete();
      }
    },
    [onDelete]
  );
  return (
    <StyledTag size={size} $color={color} highlight={highlight} {...rest}>
      {children}
      {typeof onDelete === 'function' && (
        <DeleteButton onClick={handleOnDelete}>{'\u2716'}</DeleteButton>
      )}
    </StyledTag>
  );
}

export default Tag;
